import React, { Component } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

// import './Rooms.css';

class About extends Component {
    render() {
        return (
            <div className="Rooms" ref={(div) => (this.appContainer = div)}>
                <Header />
                <div className="Rooms-container">
                    <div className="Room-top"></div>
                    <div className="Room-mid">
                        <div className="Room-header">ABOUT</div>
                        <hr />
                        <div className="Room-listing">
                            <p>
                                The Bunker Experience is a live adventure escape game with an immersive story that expands through chapters. YOU are given a mission and have to escape by solving puzzles and finding clues before time runs out.
                            </p>

                            <p>
                                <b>Escape Rooms:</b><br />
                                All our games are private. You will have the entire room to yourselves and never teamed up with other players.
                                All our games are interactive and involve live actors.
                                Our escape rooms are connected story-wise through chapters but do not have to be played in order.
                            </p>

                            <p>
                                <b>Age requirements:</b><br />
                                The Bunker Experience is suitable for ages 8 and up. Players under the age of 18 do not need to be accompanied by an adult; but must have a waiver signed by a parent or legal guardian prior to game start. 
                            </p>
                        </div>
                        <br></br><br></br><br></br>
                        <div className="Room-header">STORY</div>
                        <hr />
                        <div className="Room-listing">
                            <p>
                                2078. Global warming has taken its toll on earth, wiping out nearly 90% of humanity. The few remaining survivors live in self-sufficient underground compounds, connected by a secure communications network known as the Mainframe.

                            </p>

                            <p>
                                The largest and most advanced of these sanctuaries is the United Human Compound (UHC)—the safests and most well-equipped  place to find protection against the elements and vandal attacks.
                            </p>

                            <p>
                                The Vandals are a group of savages - led by Lightcrawler- who roam the world “Topside” looking for every opportunity to loot and kill anyone they come across Their mission is simple: find the UHC, orchestrate a massacre and seize control of humanity's final refuge.
                            </p>

                            <p>
                                For security, the UHC's location is known only to a select few compound leaders. One of those compounds—The Bunker—has just been overrun. Any live survivors are unknown.
                            </p>

                            <p>
                                Now the Vandals are hunting you.
                            </p>
                            <p>
                                Protect the UHC from being discovered. You are our only hope! Complete your mission... and RUN.
                            </p>
                        </div>
                        <br></br>
                    </div>
                    <div className="Room-bottom"></div>
                </div>

                <Footer />
            </div>
        );
    }
}

export default About;
